import {LoadingSpinnerIcon, MinusIcon, PlusIcon, TrashFilledIcon} from "../icons";
import {Heading3} from "../text";
import React from "react";
import {useTranslation} from "next-i18next";


export interface AddToCartCounterProps {
  quantity: number
  isLoading: boolean
  onIncrementClick: () => void
  onDecrementClick: () => void
}

export const AddToCartCounter: React.FC<AddToCartCounterProps> = (props) => {
  const { t } = useTranslation()
  const { isLoading } = props

  return (
    <div>
      <div className={`${props.quantity > 0 ? '' : 'hidden'}`}>
        <div
          className="transition-all text-fg-black cursor-pointer w-auto inline-flex flex-row items-center rounded-full bg-white ring-1 ring-fg-gray-surface shadow-lg"
        >
          <button onClick={e => {
            e.stopPropagation()
            props.onDecrementClick()
          }} className="hover:bg-fg-gray-lightest h-10 w-10 p-3 lg:m-0.5 lg:h-12 lg:w-12 lg:p-3 ring-inset flex-none rounded-full center">
            { props.quantity === 1 ? <TrashFilledIcon className="h-4 w-4 lg:h-6 lg:w-6 lg:p-0.5"/> : <MinusIcon className="h-4 w-4 lg:h-6 lg:w-6 lg:p-0.5"/>}
          </button>

          <div className="flex-grow w-12 relative">
            <Heading3 className={`text-center ${isLoading ? 'opacity-0' : 'opacity-100'}`}>{props.quantity}</Heading3>
            <div className={`${isLoading ? '' : 'hidden'} absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 h-full w-full flex items-center justify-center`}>
              <LoadingSpinnerIcon className="animate-spin h-5 w-5 z-10 text-fg-black" />
            </div>
          </div>

          <button onClick={e => {
            e.stopPropagation()
            props.onIncrementClick()
          }} className="hover:bg-fg-gray-surface h-10 w-10 p-3 lg:m-0.5 lg:h-12 lg:w-12 lg:p-3 ring-inset flex-none rounded-full center">
            <PlusIcon className="h-4 w-4 lg:h-6 lg:w-6 lg:p-0.5" />
          </button>
        </div>
      </div>

      <div className={`${props.quantity > 0 ? 'hidden' : ''}`}>
        <button
          className="transition-all duration-300 cursor-pointer px-1 lg:px-0.5 group-hover:px-0 ring-1 ring-fg-gray-surface group-hover:ring-1 group-hover:ring-fg-gray-surface group-hover:bg-fg-white group-hover:text-fg-black w-auto inline-flex flex-row items-center rounded-full bg-white filter shadow-lg"
          onClick={e => {
            e.stopPropagation()
            props.onIncrementClick()
          }}
        >
          <div className="relative hover:bg-fg-gray-surface text-fg-black inline-flex flex-row items-center p-2 md:p-3 rounded-full transition-all duration-300">
            <div>
              <PlusIcon className={`h-4 w-4 lg:h-6 lg:w-6 lg:p-0.5 ${isLoading ? 'opacity-0' : 'opacity-100'}`} />
            </div>
            <Heading3 className={`overflow-hidden whitespace-nowrap ml-0 transition-all duration-300 ease-in-out w-0 invisible group-hover:ml-3 group-hover:visible group-hover:w-auto ${isLoading ? 'opacity-0' : 'opacity-0 group-hover:opacity-100'}`}>
              {t('store:store_button_add_to_cart')}
            </Heading3>
            <div className={`${isLoading ? '' : 'hidden'} absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 h-full w-full flex items-center justify-center`}>
              <LoadingSpinnerIcon className="animate-spin h-5 w-5 z-10 text-fg-black" />
            </div>
          </div>
        </button>
      </div>
    </div>
  )
}